import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לנתק",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה לתקן.",
      "אני רק שם/ה לב לנתק כמו שהוא.",
      "זה מספיק לרגע."
    ],
      [
      "היום אני לא מנסה לתקן.",
      "אני רק שם/ה לב לנתק כמו שהוא.",
      "זה מספיק לרגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני הכי מרגיש/ה את הנתק?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ],
      [
      "מתי אני הכי מרגיש/ה את הנתק?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב לנתק זה כבר חיבור עדין."
    ],
      [
      "לשים לב לנתק זה כבר חיבור עדין."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המילים \"אני כאן\".",
      "נשימה אחת עם המילים \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה חסר שם",
    opening: localizedGenderNode(
      [
      "היום אני שואל/ת מה חסר לי בקשר הזה.",
      "לא להאשים.",
      "רק לזהות."
    ],
      [
      "היום אני שואל/ת מה חסר לי בקשר הזה.",
      "לא להאשים.",
      "רק לזהות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה חסר לי מהמשפחה או מהילדים?",
      "מה הייתי רוצה שיראו בי?",
      "מה קשה לי לבקש?"
    ],
      [
      "מה חסר לי מהמשפחה או מהילדים?",
      "מה הייתי רוצה שיראו בי?",
      "מה קשה לי לבקש?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "חסר קטן יכול להסביר הרבה."
    ],
      [
      "חסר קטן יכול להסביר הרבה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על החסר.",
      "לכתוב מילה אחת על החסר."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "מה השתנה בינינו",
    opening: localizedGenderNode(
      [
      "היום אני מסתכל/ת על השינוי.",
      "בלי שיפוט.",
      "רק לראות."
    ],
      [
      "היום אני מסתכל/ת על השינוי.",
      "בלי שיפוט.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה השתנה בזמן האחרון?",
      "מה היה פעם שהיום חסר?",
      "מה אני מתגעגע/ת אליו?"
    ],
      [
      "מה השתנה בזמן האחרון?",
      "מה היה פעם שהיום חסר?",
      "מה אני מתגעגע/ת אליו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "געגוע הוא סימן לחיבור שהיה."
    ],
      [
      "געגוע הוא סימן לחיבור שהיה."
    ]
    ),
    action: localizedGenderNode(
      "לזכור רגע אחד טוב.",
      "לזכור רגע אחד טוב."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "מה אני שומר/ת בפנים",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת מה אני מחזיק/ה בפנים.",
      "לא כדי לשחרר.",
      "רק לראות."
    ],
      [
      "היום אני בודק/ת מה אני מחזיק/ה בפנים.",
      "לא כדי לשחרר.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הבטן."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הבטן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני לא אומר/ת להם?",
      "למה אני שותק/ת על זה?",
      "מה אני מפחד/ת שיקרה אם אגיד?"
    ],
      [
      "מה אני לא אומר/ת להם?",
      "למה אני שותק/ת על זה?",
      "מה אני מפחד/ת שיקרה אם אגיד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "שקט לפעמים נועד להגן."
    ],
      [
      "שקט לפעמים נועד להגן."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב משפט אחד שלא אמרתי.",
      "לכתוב משפט אחד שלא אמרתי."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הפחד שמתחת לנתק",
    opening: localizedGenderNode(
      [
      "היום אני שואל/ת מה מפחיד אותי בקירבה.",
      "לא להילחם.",
      "רק לדעת."
    ],
      [
      "היום אני שואל/ת מה מפחיד אותי בקירבה.",
      "לא להילחם.",
      "רק לדעת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מפחד/ת שיקרה אם אתקרב?",
      "על מה אני מנסה להגן?",
      "איך הפחד הזה שומר עליי?"
    ],
      [
      "מה אני מפחד/ת שיקרה אם אתקרב?",
      "על מה אני מנסה להגן?",
      "איך הפחד הזה שומר עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם פחד הוא סימן לרצון בקשר."
    ],
      [
      "גם פחד הוא סימן לרצון בקשר."
    ]
    ),
    action: localizedGenderNode(
      "לומר לעצמי \"אני רואה אותך\".",
      "לומר לעצמי \"אני רואה אותך\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "רגע חיבור קטן",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת רגע חיבור קטן.",
      "לא גדול.",
      "מספיק קטן."
    ],
      [
      "היום אני מחפש/ת רגע חיבור קטן.",
      "לא גדול.",
      "מספיק קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי היה רגע קטן של חיבור?",
      "מה אפשר אותו?",
      "איך אני יכול/ה להזמין עוד רגע כזה?"
    ],
      [
      "מתי היה רגע קטן של חיבור?",
      "מה אפשר אותו?",
      "איך אני יכול/ה להזמין עוד רגע כזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רגע קטן משנה את ההרגשה."
    ],
      [
      "רגע קטן משנה את ההרגשה."
    ]
    ),
    action: localizedGenderNode(
      "לזכור רגע כזה.",
      "לזכור רגע כזה."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "להישאר עוד רגע",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להישאר עוד רגע בקשר.",
      "לא לברוח מהר.",
      "רק רגע."
    ],
      [
      "היום אני מתרגל/ת להישאר עוד רגע בקשר.",
      "לא לברוח מהר.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי אני נסוג/ת מהר?",
      "מה מפחיד אותי אם אני נשאר/ת?",
      "מה יקרה אם אשאר עוד 10 שניות?"
    ],
      [
      "מתי אני נסוג/ת מהר?",
      "מה מפחיד אותי אם אני נשאר/ת?",
      "מה יקרה אם אשאר עוד 10 שניות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "עוד רגע אחד יכול לשנות משהו."
    ],
      [
      "עוד רגע אחד יכול לשנות משהו."
    ]
    ),
    action: localizedGenderNode(
      "לעצור 10 שניות לפני שאני נסוג/ת.",
      "לעצור 10 שניות לפני שאני נסוג/ת."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "מילה אחת רכה",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת מילה אחת רכה שאני יכול/ה להביא.",
      "לא הרבה.",
      "מילה אחת."
    ],
      [
      "היום אני בודק/ת מילה אחת רכה שאני יכול/ה להביא.",
      "לא הרבה.",
      "מילה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו מילה רכה הייתי רוצה לומר?",
      "למי הייתי רוצה לומר אותה?",
      "איך זה מרגיש לי להגיד אותה?"
    ],
      [
      "איזו מילה רכה הייתי רוצה לומר?",
      "למי הייתי רוצה לומר אותה?",
      "איך זה מרגיש לי להגיד אותה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מילה אחת יכולה לפתוח לב."
    ],
      [
      "מילה אחת יכולה לפתוח לב."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת רכה.",
      "לכתוב מילה אחת רכה."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "בקשה אחת",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה אחת קטנה.",
      "לא דרישה.",
      "בקשה."
    ],
      [
      "היום אני מנסח/ת בקשה אחת קטנה.",
      "לא דרישה.",
      "בקשה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הייתי רוצה לבקש בעדינות?",
      "איך אפשר לומר זאת ברוך?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "מה הייתי רוצה לבקש בעדינות?",
      "איך אפשר לומר זאת ברוך?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לשנות קצב."
    ],
      [
      "בקשה אחת יכולה לשנות קצב."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "לראות את הצד השני",
    opening: localizedGenderNode(
      [
      "היום אני מנסה לראות גם את הצד השני.",
      "בלי להצדיק.",
      "רק לראות."
    ],
      [
      "היום אני מנסה לראות גם את הצד השני.",
      "בלי להצדיק.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני כאן."
    ],
      [
      "אני נושם/ת לאט.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אולי קשה גם להם?",
      "מה הם אולי מפחדים לאבד?",
      "מה משתנה בי כשאני רואה את זה?"
    ],
      [
      "מה אולי קשה גם להם?",
      "מה הם אולי מפחדים לאבד?",
      "מה משתנה בי כשאני רואה את זה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ראייה רחבה יכולה לרכך כאב."
    ],
      [
      "ראייה רחבה יכולה לרכך כאב."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת של רכות כלפיהם.",
      "לכתוב מילה אחת של רכות כלפיהם."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "הערך שמחזיק אותנו",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת ערך אחד שמחזיק את הקשר.",
      "קטן.",
      "אבל אמיתי."
    ],
      [
      "היום אני מחפש/ת ערך אחד שמחזיק את הקשר.",
      "קטן.",
      "אבל אמיתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה ערך חשוב לי במשפחה?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכול לכבד אותו?"
    ],
      [
      "איזה ערך חשוב לי במשפחה?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכול לכבד אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ערך אחד יכול להיות חוט של חיבור."
    ],
      [
      "ערך אחד יכול להיות חוט של חיבור."
    ]
    ),
    action: localizedGenderNode(
      "מילה אחת שמבטאת את הערך.",
      "מילה אחת שמבטאת את הערך."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "לחזור לעצמי בתוך הקשר",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך לחזור לעצמי בתוך המשפחה.",
      "לא לברוח.",
      "רק לחזור."
    ],
      [
      "היום אני בודק/ת איך לחזור לעצמי בתוך המשפחה.",
      "לא לברוח.",
      "רק לחזור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הרגליים."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הרגליים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה מחזיר אותי לעצמי בקשר הזה?",
      "מה מוציא אותי מעצמי?",
      "מה יכול לעזור לי לחזור?"
    ],
      [
      "מה מחזיר אותי לעצמי בקשר הזה?",
      "מה מוציא אותי מעצמי?",
      "מה יכול לעזור לי לחזור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לחזור לעצמי הוא גם חיבור."
    ],
      [
      "לחזור לעצמי הוא גם חיבור."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשאני עם המשפחה.",
      "נשימה אחת כשאני עם המשפחה."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן של קירבה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן של קירבה.",
      "בלי דרמה.",
      "צעד קטן."
    ],
      [
      "היום אני בוחר/ת צעד קטן של קירבה.",
      "בלי דרמה.",
      "צעד קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ],
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעד קטן מספיק כדי לזוז."
    ],
      [
      "צעד קטן מספיק כדי לזוז."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד אחד קטן ולזכור אותו.",
      "לבחור צעד אחד קטן ולזכור אותו."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לקרבה.",
      "כשאני מרגיש/ה רחוק/ה.",
      "משפט קטן."
    ],
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לקרבה.",
      "כשאני מרגיש/ה רחוק/ה.",
      "משפט קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הנתק הזה?",
      "מה הסימן הראשון שהוא חוזר?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ],
      [
      "מה למדתי על הנתק הזה?",
      "מה הסימן הראשון שהוא חוזר?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה להרגיש רחוק/ה ולהישאר עם עצמי."
    ],
      [
      "אני יכול/ה להרגיש רחוק/ה ולהישאר עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט החדש פעם אחת.",
      "לומר את המשפט החדש פעם אחת."
    ),
  },
].map(buildNormalizedDay);

export const feelingDisconnectedFromTheFamilyChildrenBlueprintHe = buildNormalizedPilotBlueprint({
  id: "feeling_disconnected_from_the_family_children_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "feeling_disconnected_from_the_family_children",
  category: "loneliness_belonging",
  journeyName: {
    he: "תחושת נתק מהמשפחה / מהילדים",
    en: "Feeling disconnected from the family / children",
    es: "Sensación de desconexión de la familia / de los hijos",
  },
  days,
});

export default feelingDisconnectedFromTheFamilyChildrenBlueprintHe;
